/**
 *  Pickup
 *
 *  Created by Legman on 21/03/2017.
 *
 */

import Common       from "./Common";
import RaceEntity   from "./race/RaceEntity";

/**
 * @class
 * @extends RaceEntity
 */
export default class Pickup extends RaceEntity {
    constructor() {
        const assets = Common.assets;
        super(RaceEntity.TYPE_STATIC, new PIXI.Sprite(assets.getTexture("powerup_mystery_object_00")));

        this.collisionWidth = 60;
        this.collisionLength = 34;
        this.view.anchor = new PIXI.Point(0.5, 0.5);

        /**
         * @param {signals.Signal}
         */
        this.signals.collect = new signals.Signal();

        /**
         * @type {number}
         */
        this.respawnDelay = 4;

        /**
         * @param {boolean}
         * @private
         */
        this._collected = false;

        /**
         * @type {Array.<TweenMax>}
         * @private
         */
        this._tweens = [];
    }

    /**
     */
    init() {
        super.init();

        this.startOffsetY = this.offset.y;

        this._tweens.push(TweenMax.to(this.offset, 0.8, {
            y: this.offset.y + 40.0,
            ease: Power1.easeInOut,
            yoyo: true,
            repeat: -1
        }));
    }

    /**
     * @param dt
     */
    update(dt) {
    }

    /**
     */
    destroy() {
        this.signals.collect.dispose();

        this.killAllTweens();

        super.destroy();
    }

    /**
     */
    reset() {
        this.offset.y = this.startOffsetY;
        this._collected = false;
        this.renderToWorld = true;
        this._view.alpha = 1;
        this._view.visible = true;

        this.killAllTweens();
        this.init();
    }

    /**
     */
    killAllTweens() {
        for (let i = 0; i < this._tweens.length; ++ i) {
            const tween = this._tweens[i];
            tween.kill();
        }
        this._tweens.length = 0;
    }

    /**
     * @param {RaceCar} collector
     * @returns {boolean}
     */
    collect(collector) {
        if (this._collected) return false;

        this._collected = true;
        this.renderToWorld = false;

        collector.jump(false);

        if (collector.id === Common.playerDriverId) {
            let tl = new TimelineMax();
            this._tweens.push(tl);

            tl.append(TweenMax.to(this._view.scale, 0.2, {
                x: 1,
                y: 1,
                ease: Back.easeOut,
                easeParams: [1]
            }));

            tl = new TimelineMax();
            this._tweens.push(tl);

            tl.append(TweenMax.to(this._view, 0.2, {
                x: collector.view.x,
                y: collector.view.y,
                ease: Power1.easeInOut
            }));
            tl.append(TweenMax.to(this._view, 0.34, {
                y: collector.view.y - 200,
                ease: Power2.easeInOut,
                onComplete: function() {
                    this._view.texture = Common.assets.getTexture("powerup_mystery_object_01");
                    (collector.id === Common.playerDriverId) && Common.audio.playSound("sfx_crate_open_squeak_00");

                    delay(function() {
                        this.signals.collect.dispatch(this, collector);
                    }, 0.4, this);
                },
                onCompleteScope: this
            }));
            tl.append(TweenMax.to(this._view, 0.34, {
                delay: 0.2,
                alpha: 0,
                ease: Power1.easeInOut,
                onComplete: function() {
                    this._view.texture = Common.assets.getTexture("powerup_mystery_object_00");
                    this._view.visible = false;
                },
                onCompleteScope: this
            }));
        } else {
            this.view.visible = false;
            this.signals.collect.dispatch(this, collector);
        }

        delay(this.reset, this.respawnDelay, this);

        // only play this sound if the player grabs
        (collector.id === Common.playerDriverId) && Common.audio.playSound("sfx_pickup_powerup_crate_00");
        return true;
    }

    /**
     * @returns {boolean}
     */
    get collected() {
        return this._collected;
    }
}